import * as React from 'react';
import { useIntl } from 'react-intl';

import { PageHeader } from 'modules/experience-core';

import { SupportLayer } from './SupportLayer/SupportLayer';

export const ExperienceSupportLayer = () => {
  const { formatMessage } = useIntl();

  const pageHeader = (
    <PageHeader
      title={formatMessage({
        id: 'support.page-title',
      })}
      enableSelector={false}
    />
  );

  return <SupportLayer pageHeader={pageHeader} />;
};
